<div class="brand-plp-product-list">
  <app-products-grid
    *ngIf="products !== null"
    [products]="products"
    [isDesktop]="isDesktop"
    [isMobile]="!isDesktop"
    [isCustomPLPPage]="false"
    (productClicked)="onProductClick($event.product, $event.priceType, $event.index)"
    (productVisibilityChange)="onProductVisibility($event.isVisible, $event.index)"
    (indexPower10ProductVisible)="onIndexPower10ProductVisible($event)"
  ></app-products-grid>
</div>
